module.exports = __webpack_public_path__ + "img/1.2143e461.png";